import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/home";
import TorontoPage from "./pages/toronto";
import MockTest from "./pages/MockTest";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import Checkout from "./pages/Checkout";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { AuthProvider } from "./context/AuthContext";
import { AdminProvider } from "./context/AdminContext";
import { LanguageProvider } from "./context/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import LearningHub from "./pages/LearningHub";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCategories from "./pages/AdminCategories";
import AdminNews from "./pages/AdminNews";
import NotFoundPage from "./pages/404";
import NewsDetail from "./pages/NewsDetail";
import NewsList from "./pages/NewsList";
import VotePopup from "./components/VotePopup";

function App() {
  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: "CAD",
    intent: "capture",
  };

  return (
    <LanguageProvider>
      <AuthProvider>
        <AdminProvider>
          <PayPalScriptProvider options={initialOptions}>
          <Router>
            <VotePopup />
            <Routes>
              {/* User Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/learning"
                element={
                  <ProtectedRoute>
                    <LearningHub />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/practice" 
                element={
                  <ProtectedRoute>
                    <HomePage />
                  </ProtectedRoute>
                } 
              />
              <Route path="/toronto" element={<TorontoPage />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route 
                path="/mock-test" 
                element={
                  <ProtectedRoute>
                    <MockTest />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/checkout" 
                element={
                  <ProtectedRoute>
                    <Checkout />
                  </ProtectedRoute>
                } 
              />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/dashboard" 
                element={
                  <AdminProtectedRoute>
                    <AdminDashboard />
                  </AdminProtectedRoute>
                } 
              />
              <Route 
                path="/admin/categories" 
                element={
                  <AdminProtectedRoute>
                    <AdminCategories />
                  </AdminProtectedRoute>
                } 
              />
              <Route 
                path="/admin/news" 
                element={
                  <AdminProtectedRoute>
                    <AdminNews />
                  </AdminProtectedRoute>
                } 
              />

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Router>
        </PayPalScriptProvider>
        </AdminProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
